<template>
    <q-card flat>
        <q-card-section>
            <div class="text-h5 text-bold text-uppercase">Features</div>
        </q-card-section>
        <q-card-section class="q-pt-none  q-pl-sm" v-if="processedData[version] && processedData[version]['coastalOffshore'] && processedData[version]['coastalOffshore']['offshore']">
            <q-list bordered class="rounded-borders bottom-border" role="list" >
                <q-expansion-item  v-model="summary" group="features" header-class="bg-grey-5"  expand-separator dense  @click="goTo('summary', 'FEATURES_SUMMARY')"  class="exp-panel" role="listitem">
                    <template v-slot:header>
                        <q-item-section class="text-uppercase text-bold">
                                Summary
                        </q-item-section>
                        <q-item-section v-if="summary">
                            <div class="row justify-end">
                                <div class="q-mt-xs q-mb-xs q-pl-sm q-pr-sm shadow-1 rounded"  @click.stop="print('featureSummaryPane', version, 'Features Summary')" v-if="!printing" aria-label="Print summary"><q-icon name="print" size="xs"></q-icon></div>
                                <q-spinner v-else />
                            </div>
                        </q-item-section>
                    </template>
                    <router-view v-if="summary" :data="rawData" :version="version"></router-view>
                </q-expansion-item>     
                <q-expansion-item  v-model="seafloor" group="features"  expand-separator dense  @click="goTo('seafloor', 'SEAFLOOR_FEATURES')"  class="exp-panel" role="listitem">
                    <template v-slot:header>
                        <q-item-section class="text-uppercase text-bold">
                                Seafloor Features
                        </q-item-section>
                        <!-- <q-item-section v-if="seafloor">
                            <div class="row justify-end">
                                <q-btn class="q-mt-xs" icon="print"size="sm" @click.stop="print('seafloorFeaturePane', version, 'Seafloor Features')" v-if="!printing"/>
                                <q-spinner v-else />
                            </div>
                        </q-item-section> -->
                    </template>
                    <router-view v-if="seafloor" :data="rawData" :version="version"></router-view>
                </q-expansion-item>     
                <q-expansion-item
                    group="features"
                    dense
                    class="exp-panel"
                    expand-separator
                    label="Data Considerations"
                    @click="goTo('data')" 
                    v-model="dataqual"
                    header-class="bg-grey-5" 
                    role="listitem"
                >
                    <template v-slot:header>
                        <q-item-section class="text-uppercase text-bold">
                                Data Considerations
                        </q-item-section>
                        <q-item-section v-if="dataqual">
                            <div class="row justify-end">
                                <div class="q-mt-xs q-mb-xs q-pl-sm q-pr-sm shadow-1 rounded"  @click.stop="print('featuresDataConsiderationsPane', version, 'Features Data Considerations')" v-if="!printing" aria-label="Print summary"><q-icon name="print" size="xs"></q-icon></div>
                                <q-spinner v-else />
                            </div>
                        </q-item-section>
                    </template>
                    <router-view v-if="dataqual" :data="rawData" :version="version"></router-view>
                </q-expansion-item>       
            </q-list>            
        </q-card-section>
        <q-card-section v-else>
            <div class="text-center text-h5">The AOI does not include any offshore areas.</div>
        </q-card-section>
    </q-card>
</template>
<script setup>
import { toRefs, ref, computed, onMounted, watch } from "vue";
import { useHelpers } from "../composables/useHelpers"
import { useMapItems } from "../composables/useMapItems"
import { useRouter, useRoute } from 'vue-router'
import DataQuality from "./DataQuality.vue";
import EcoregionSummary from "./EcoregionSummary.vue";
import SeafloorFeatures from "./SeafloorFeatures.vue";
const router = useRouter()
const route = useRoute()

const { print, printing, processedData, loadDataByID } = useMapItems()
const { logGAevent } = useHelpers();

const props = defineProps({
    rawData: { type: Object },
    version: {type: Number}
})

const { rawData, version } = toRefs(props)

const seafloor = ref(false)
const summary = ref(false)
const dataqual = ref(false)
const panelRefs = {
    seafloor,
    summary
}
const setExpansionPanel = (refName, value) =>{
  if (panelRefs[refName]) {
    panelRefs[refName].value = value;
  }
}

const goTo = (pane, layerID=null) =>{
  logGAevent("features_pane", pane, "")
  if (layerID){
    loadDataByID(layerID, version)
  }
  router.push({
    path: `/results${version.value}/features/${pane}`
  })
}

const setPanels = (path) =>{
    if (path.includes('features/summary')){
        setExpansionPanel('summary', true)
    }
    if (path.includes('features/seafloor')){
        setExpansionPanel('seafloor', true)
    }
    if (path.includes('features/data')){
        setExpansionPanel('dataQual', true)
    }
}

watch(route, (nv, ov) =>{
    setPanels(nv.fullPath)
})

onMounted(() => {
    // if coming from a route (entered via URL).  expand the correct panel
    setPanels(route.path)
})

</script>
<style scoped>
.rounded{
    border-radius: 3px;
}
.exp-panel{
    border-top: 1px solid #aeaeae;
    border-left: 1px solid #aeaeae;
    border-right:1px solid #aeaeae;
    background-color: #f7f7f7;
 }
 .bottom-border{
    border-bottom:1px solid #aeaeae !important;
 }
 </style>